export const metadata = {
  title: 'Why Mora | Premium Indian Snacking',
  description: 'Discover why Mora stands out - premium peanuts, dry roasted for natural flavour, and protein-rich.',
};

import BenefitsHero from 'components/why/BenefitsHero';
import WhyStory from 'components/why/WhyStory';
import BenefitsGrid from 'components/why/BenefitsGrid';
import PageMeta from 'components/layout/PageMeta';

export default function WhyMoraPage() {
  return (
    <main className="min-h-screen bg-Mora-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      <BenefitsHero />
      <WhyStory />
      <BenefitsGrid />
    </main>
  );
}
